import {
  UPDATE_SEARCH,
  UPDATE_ENTRIES,
  PUSH_DETAILS,
  POP_DETAILS,
  CLEAR_DETAILS,
  CLEAR_ENTRIES,
  CLEAR_SEARCH,
  SET_SERVER_INSTANCE,
  SET_DATA_SOURCE,
  SET_CERTIFICATE_TYPE,
  SET_CERTIFICATE_LABEL,
  SET_LOGPAGE_NUM,
  SET_RECENT_ENTRY,
  SET_SELECTED_AUTHORITY,
  SET_REQUEST_MESSAGE,
  SET_PROCESSING_STATE
} from "../actionTypes/actionTypes";

const initialSearchState = {
  authorityName: "",
  requestDate: "",
  requestId: "",
  patientDob: "",
  patientFirstName: "",
  patientLastName: "",
  topCount: 100,
  serverInstance: "Prod",
  dataSource: "Prod",
  desc: true
}

const initialStoreState = {
  serverInstance: "Prod",
  dataSource: "Prod",
  searchModel: initialSearchState,
  certificateType: 1,
  certificateLabel: "School",
  selectedDetails: undefined,
  data: [],
  detailsHistory: [],
  modalShow: false,
  currentLogPage: 1,
  processingState: false,
  requestMessage: undefined
};

// NOTE: 
// It is important to pass an initial state as default to 
// the state parameter to handle the case of calling 
// the reducers for the first time when the 
// state might be undefined

export const logReducer = (state = initialStoreState, action) => {
  switch (action.type) {
    case UPDATE_SEARCH:
      return {
        ...state,
        searchModel: action.payload,
      };

    case UPDATE_ENTRIES:
      return {
        ...state,
        data: action.payload
      };

    case PUSH_DETAILS:
      let foundIndex = state.detailsHistory.findIndex(item => item.id === action.payload.id);
      if (foundIndex === -1) {
        return {
          ...state,
          selectedDetails: action.payload,
          detailsHistory: [
            ...state.detailsHistory, action.payload
          ]
        };
      }
      else {
        return {
          ...state,
          selectedDetails: action.payload
        };
      }

    case POP_DETAILS:
      return {
        ...state,
        selectedDetails: state.detailsHistory.slice(-1),
        detailsHistory: state.detailsHistory.slice(0, state.detailsHistory.length - 1)
      };

    case CLEAR_SEARCH:
      return {
        ...state,
        searchModel: initialSearchState
      };

    case CLEAR_DETAILS:
      return {
        ...state,
        detailsHistory: []
      };

    case CLEAR_ENTRIES:
      return {
        ...state,
        data: []
      };

    case SET_SERVER_INSTANCE:
      return {
        ...state,
        serverInstance: action.payload,
        searchModel: {
          ...state.searchModel,
          serverInstance: action.payload
        }
      };

    case SET_DATA_SOURCE:
      return {
        ...state,
        dataSource: action.payload,
        searchModel: {
          ...state.searchModel,
          dataSource: action.payload
        }
      };

    case SET_CERTIFICATE_TYPE:
      return {
        ...state,
        certificateType: action.payload
      };

    case SET_CERTIFICATE_LABEL:
      return {
        ...state,
        certificateLabel: action.payload
      };

    case SET_LOGPAGE_NUM:
      return {
        ...state,
        currentLogPage: action.payload
      };

    case SET_RECENT_ENTRY:
      let entry = state.detailsHistory.find(e => e.id === action.payload);
      return {
        ...state,
        selectedDetails: entry,
        requestMessage: JSON.stringify(entry, null, 2)
      };

    case SET_SELECTED_AUTHORITY:
      return {
        ...state,
        searchModel: {
          ...state.searchModel,
          authorityName: action.payload
        }
      };

    case SET_REQUEST_MESSAGE:
      return {
        ...state,
        requestMessage: action.payload
      };

    case SET_PROCESSING_STATE:
      return {
        ...state,
        processingState: action.payload
      };

    default:
      return state;
  }
};    
          
